<template>
  <v-slider 
    :class="conditionalClasses"
    :value='speed' 
    @input='handleSpeedChange' 
    :label='label'
    :min='1' 
    :max='5' 
    :tick-labels="reactiveTickLabels"/>
</template>

<script>
  import { defineComponent, computed } from 'vue'

  export default defineComponent({
    props: {
      speed: {
        type: Number,
        default: 3
      },
      label: {
        type: String,
        default: 'Speed'
      },
      tickLabels: {
        type: Array,
        default: ()=>([])
      },
      hideLabel: {
        type: Boolean,
        default: false
      },
      hideTicks: {
        type: Boolean,
        default: true
      }
    },
    setup(props, context){
      const handleSpeedChange = (...params)=>{
        context.emit('speed-changed', ...params);
      };

      const conditionalClasses = computed(()=>{
        return {
          'speed-slider': true,
          'hide-label': props.hideLabel
        }
      })

      const reactiveTickLabels = computed(()=>{
        return props.hideTicks ? [] : props.tickLabels;
      })
      
      return {
        handleSpeedChange,
        reactiveTickLabels,
        conditionalClasses
      }
    }
  })
</script>

<style lang="scss" scoped>
.speed-slider ::v-deep {
  .v-messages {
    display: none;
  }
  .v-label{
    font-size: .875rem;
  }
  .v-slider__tick-label {
    font-size: .75rem;
  }
  .v-input__slot {
    margin-bottom: 0;
  }
}
.speed-slider.hide-label ::v-deep .v-label{
  display: none;
}
</style>